export default __webpack_public_path__ + "static/media/package.83795efa.svg";